import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import React from 'react';
import classes from './header.module.css';
const Header = ({ siteTitle }) => (
  <h1 style={{ margin: 0 }}>
    <Link
      to="/"
      style={{
        textDecoration: `none`,
        fontSize: 24,
        color: '#2c2c2d',
        paddingLeft: 16,
        fontWeight: 'bold',
        fontFamily: 'Fabriga'
      }}
    >
      {siteTitle}
    </Link>
    <div className={classes.dividerMobile} />
  </h1>
);

Header.propTypes = {
  siteTitle: PropTypes.string
};

Header.defaultProps = {
  siteTitle: ``
};

export default Header;
